// extracted by mini-css-extract-plugin
export var body = "styles-module--body--7f8d9";
export var error = "styles-module--error--a6157";
export var header = "styles-module--header--e319f";
export var overlay = "styles-module--overlay--0ecad";
export var pending = "styles-module--pending--f3791";
export var report = "styles-module--report--45aff";